export interface MEError {
    code : number,
    message : string,
    url? : string
    display?: MEErrorType
}

export enum MEErrorType {
    Popup,
    Descriptive
}
